@if (isVisible() && type === 'community') {
  <ejs-breadcrumb [enableNavigation]="false" [maxItems]="10" [overflowMode]="'Menu'" [enableActiveItemNavigation]="true" (itemClick)="routerService.navigateTo($event.item.url)" [separatorTemplate]="separatorTemplate" [cssClass]="'breadcrumb-container'">
    <e-breadcrumb-items>
      <e-breadcrumb-item iconCss="e-icons e-home lh-1" [url]="'/community/list'"></e-breadcrumb-item>
      @for (bread of breadcrumbItems; track bread.id) {
        <e-breadcrumb-item [text]="bread.title" [url]="'/community/list/community/' + bread.id"></e-breadcrumb-item>
      }
    </e-breadcrumb-items>
    <ng-template #separatorTemplate>
      <app-icon-badge [style]="'default'" [icon]="'chevron_right'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
    </ng-template>
  </ejs-breadcrumb>
} @else if(isVisible() && type === 'no_routing') {
  <ejs-breadcrumb 
    [enableNavigation]="false" 
    [maxItems]="10" 
    [overflowMode]="'Wrap'" 
    [enableActiveItemNavigation]="true" 
    (itemClick)="emitNoRoutingItemClicked($event)" 
    [separatorTemplate]="separatorTemplate" 
    [cssClass]="'breadcrumb-container w-100'"
    >
    <e-breadcrumb-items>
      <e-breadcrumb-item iconCss="e-icons e-home lh-1"></e-breadcrumb-item>
      @for (bread of breadcrumbItems; track bread.id) {
        <e-breadcrumb-item [text]="bread.title" [id]="bread.id"></e-breadcrumb-item>
      }
    </e-breadcrumb-items>
    <ng-template #separatorTemplate>
      <app-icon-badge [style]="'default'" [icon]="'chevron_right'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
    </ng-template>
  </ejs-breadcrumb>
}

